'use strict';

var _isBoolean = require('lodash/isBoolean');

var _isBoolean2 = _interopRequireDefault(_isBoolean);

var _applicationState = require('../../utils/applicationState');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uamNetworkController = {
  init: function init() {
    /*eslint-disable */
    !function (a9, a, p, s, t, A, g) {
      if (a[a9]) return;

      function q(c, r) {
        a[a9]._Q.push([c, r]);
      }

      a[a9] = {
        init: function init() {
          q('i', arguments);
        }, fetchBids: function fetchBids() {
          q('f', arguments);
        }, setDisplayBids: function setDisplayBids() {}, targetingKeys: function targetingKeys() {
          return [];
        }, _Q: []
      };
      A = p.createElement(s);
      A.async = !0;
      A.src = t;

      g = p.getElementsByTagName(s)[0];
      g.parentNode.insertBefore(A, g);
    }('apstag', window, document, 'script', '//c.amazon-adsystem.com/aax2/apstag.js');
    /*eslint-enable */

    // eslint-disable-next-line no-undef
    if (window.apstag) {
      var _getState = (0, _applicationState.getState)(_applicationState.State.ccpaStatus, {}),
          ccpaStatus = _getState.value;

      var _getState2 = (0, _applicationState.getState)(_applicationState.State.gdprData),
          gdprApplies = _getState2.gdprApplies,
          tcString = _getState2.tcString;

      var params = {
        us_privacy: ccpaStatus
      };

      if ((0, _isBoolean2.default)(gdprApplies)) {
        params.gdpr = gdprApplies ? 1 : 0;
      }

      if (tcString) {
        params.gdpr_consent = tcString;
      }

      // eslint-disable-next-line no-undef
      window.apstag.init({
        pubID: '3111b792-be07-4cd2-bd99-c42ac9a74f71',
        adServer: 'googletag',
        params: params
      });
    }
  }
};

module.exports = uamNetworkController;